<template>
  <div class="mui-list-item" role="menuitem">
    <span class="mui-list-item__graphic" v-if="$slots.graphic">
      <slot name="graphic"></slot>
    </span>
    <span class="mui-list-item__text">
      {{text}}
      <span class="mui-list-item__secondary-text" v-if="secondaryText">{{secondaryText}}</span>
      <span class="mui-list-item__note" v-if="note">{{note}}</span>
    </span>
    <span class="mui-list-item__meta" v-if="$slots.meta">
      <slot name="meta"></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    note: String,
    secondaryText: String,
    text: {
      type: String
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.mui-list-item
  align-items: end
  display: flex
  justify-content: flex-start
  overflow: hidden
  padding: 0 24px
  position: relative
  user-select: none
  .mui-list-item__graphic
    align-items: center
    display: inline-flex
    flex-shrink: 0
    justify-content: center
    margin-left: 0
    margin-right: 16px
    width: 40px
    height: 40px
  .mui-list-item__text
    overflow: hidden
  .mui-list-item__secondary-text
    text-overflow: ellipsis
    white-space: nowrap
    overflow: hidden
    display: block
  .mui-list-item__meta
    margin-left: auto
    margin-right: 0
    padding-left: 16px
.mui-list:not(.mui-list--static)
  .mui-list-item
    cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/MUIListItem.vue